// frontend/src/components/Charts/stacked-line.js
import { useEffect, useState } from 'react';
import { Chart } from 'react-google-charts';
import { ApiConsumer } from 'api/ApiConsumer';
import Loader from 'components/Loader';
import { useUtils } from 'hooks/UtilityHook';
import { monthsOfTheYear } from 'api/util';

StackedLine.defaultProps = {
  normaliseData: (res) => res,
  hasExistingData: false,
};

export function StackedLine({
  url = '',
  height = '400',
  width = '50%',
  normaliseData,
  existingData,
  hasExistingData,
  loadingExistingData,
}) {
  const [data, setData] = useState(existingData);
  const [loading, setLoading] = useState(false);
  let { getMonth } = useUtils();

  const options = {
    title: '',
    legend: { position: 'bottom' },
    chartArea: { width },
    annotations: { alwaysOutside: true },
    isStacked: true,
    hAxis: {
      title: '',
      minValue: 0,
    },
    vAxis: {
      title: '',
    },
    series: {
      0: { color: '#5fa83f' },
      1: { color: '#f72585' },
    },
  };

  useEffect(() => {
    if (!hasExistingData) {
      setLoading(true);
      ApiConsumer.get(url)
        .then((res) => {
          const result = normaliseData(res.data).reduce(
            (ret, item) => {
              // TODO: change api so that the next line is not necessary
              if (item.broadcast_stream__name === null) return ret;
              return [
                ...ret,
                [
                  getMonth(item.month || item.broadcast_stream__name),
                  item.recognised,
                  item.unrecognised,
                ],
              ];
            },
            [['Plays', 'Recognised', 'Unrecognised']],
          );

          setData(result);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [url]);

  if (!hasExistingData && loading) {
    return <Loader upload_message={'loading'} full_height={true} />;
  } else if (hasExistingData && loadingExistingData) {
    return <Loader upload_message={'loading'} full_height={true} />;
  }

  const chartData = hasExistingData ? existingData : data;
  
  function getRolling12MonthData(data, refDate = new Date()) {
    if (!data){
      return null;
    }
    const header = data[0];
    const months = data.slice(1);
    
    const currentMonthName = monthsOfTheYear[refDate.getMonth()];
    
    const currentIndex = months.findIndex(row => row[0] === currentMonthName);
    
    if (currentIndex === -1) {
      console.error(`Month "${currentMonthName}" not found in data.`);
      return data;
    }
    
    const rollingMonths = [];
    for (let i = 1; i <= 12; i++) {
      rollingMonths.push(months[(currentIndex + i) % months.length]);
    }
    
    return [header, ...rollingMonths];
  }
  
  const rollingChartData = getRolling12MonthData(chartData);

  if (!chartData || chartData.length <= 1) {
    return (
      <div
      style={{
        height: `${height}px`,
        width: '100%',
        display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f7f7f7', // optional styling
          borderRadius: '8px',
        }}
      >
        No Data Available.
      </div>
    );
  }

  return (
    <>
      <Chart
        chartType="ColumnChart"
        width="100%"
        height={`${height}px`}
        data={rollingChartData}
        options={options}
        className={'shadow rounded'}
      />
    </>
  );
}
